import React from 'react';

export default function Logo({ className = '' }) {
  return (
    <div
      className={`site-logo-wrap ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width="118"
        height="48"
        viewBox="0 0 118 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="<W> Dot Matrix Logo"
        style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
      >
        {/* LEFT BRACKET < */}
        <circle cx="22" cy="14" r="2.8" fill="#ccff00" />
        <circle cx="15" cy="21" r="2.8" fill="#ccff00" />
        <circle cx="8"  cy="28" r="3.0" fill="#ccff00" />
        <circle cx="15" cy="35" r="2.8" fill="#ccff00" />
        <circle cx="22" cy="42" r="2.8" fill="#ccff00" />

        {/* LETTER 'W' (Exact Dot Matrix Match in Acid Lime Theme Color) */}
        {/* Col 1 */}
        <circle cx="34" cy="11" r="3.0" fill="#ccff00" />
        <circle cx="34" cy="18" r="3.0" fill="#ccff00" />
        <circle cx="34" cy="25" r="3.0" fill="#ccff00" />
        <circle cx="34" cy="32" r="3.0" fill="#ccff00" />

        {/* Col 2 */}
        <circle cx="41" cy="11" r="3.0" fill="#ccff00" />
        <circle cx="41" cy="18" r="3.0" fill="#ccff00" />
        <circle cx="41" cy="25" r="3.0" fill="#ccff00" />
        <circle cx="41" cy="32" r="3.0" fill="#ccff00" />
        <circle cx="41" cy="39" r="3.0" fill="#ccff00" />

        {/* Col 3 */}
        <circle cx="48" cy="39" r="3.0" fill="#ccff00" />
        <circle cx="48" cy="45" r="3.0" fill="#ccff00" />

        {/* Col 4 */}
        <circle cx="54" cy="32" r="3.0" fill="#ccff00" />

        {/* Col 5 (Center Column) */}
        <circle cx="61" cy="11" r="3.0" fill="#ccff00" />
        <circle cx="61" cy="18" r="3.0" fill="#ccff00" />
        <circle cx="61" cy="25" r="3.0" fill="#ccff00" />
        <circle cx="61" cy="32" r="3.0" fill="#ccff00" />

        {/* Col 6 */}
        <circle cx="68" cy="39" r="3.0" fill="#ccff00" />
        <circle cx="68" cy="45" r="3.0" fill="#ccff00" />

        {/* Col 7 */}
        <circle cx="74" cy="32" r="3.0" fill="#ccff00" />

        {/* Col 8 */}
        <circle cx="81" cy="11" r="3.0" fill="#ccff00" />
        <circle cx="81" cy="18" r="3.0" fill="#ccff00" />
        <circle cx="81" cy="25" r="3.0" fill="#ccff00" />

        {/* RIGHT BRACKET > WITH BREATHE EFFECT (Yanıp Sönen Nabız Animasyonu) */}
        <g className="logo-bracket-breathe">
          <circle cx="94"  cy="14" r="2.8" fill="#ccff00" />
          <circle cx="101" cy="21" r="2.8" fill="#ccff00" />
          <circle cx="108" cy="28" r="3.0" fill="#ccff00" />
          <circle cx="101" cy="35" r="2.8" fill="#ccff00" />
          <circle cx="94"  cy="42" r="2.8" fill="#ccff00" />
        </g>
      </svg>
    </div>
  );
}
